module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_a-function.js
// module id = 11
// module chunks = 0